'use client';

import type { Exploit } from '@revoke.cash/core/exploits';
import { useAddress } from 'lib/hooks/page-context/AddressIdentityContext';
import PremiumExploitCta from './PremiumExploitCta';
import PremiumExploitDashboard from './PremiumExploitDashboard';

interface Props {
  exploits: Exploit[];
}

const ExploitsPageContent = ({ exploits }: Props) => {
  const { isPremium } = useAddress();
  return isPremium ? <PremiumExploitDashboard exploits={exploits} /> : <PremiumExploitCta />;
};

export default ExploitsPageContent;
